import script from "./AlienProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./AlienProfile.vue?vue&type=script&setup=true&lang=js"

import "./AlienProfile.vue?vue&type=style&index=0&id=58132715&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58132715"]])

export default __exports__